import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { map, timeout, catchError } from 'rxjs/operators';
import { ApiCommonService } from 'cbc-shared-lib';
import { Szza016aRequest, Szza016aResponse, SZZA016AService } from 'sg-api';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

@Injectable({
  providedIn: 'root'
})
export class UsedSzza016aService {
  /** ファイルリスト取得結果のSubject */
  private _getFileListResult$: Subject<Szza016aResponse> = new Subject<Szza016aResponse>();

  /**
   * ファイルリスト取得結果のobservable提供
   *
   * @readonly
   * @memberof UsedSzza016aService
   */
  get fileListValueChanges(): Observable<Szza016aResponse> {
    return this._getFileListResult$.asObservable();
  }

  /**
   * コンストラクタ
   * @param {SZZA016AService} sZZA016AService
   * @memberof InitialInfoService
   */
  constructor(private sZZA016AService: SZZA016AService, private apiCommonService: ApiCommonService, @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * ファイルリスト取得API呼び出し
   *
   * @param {*} value
   * @memberof UsedSzza016aService
   */
  getFileList(request: Szza016aRequest, noCheckError:boolean = false): Observable<Szza016aResponse> {
    return this.sZZA016AService.a10RSZZA016APost(this.apiCommonService.setRequestCommon(request),'response')
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          //  if(noCheckError){
          //   this.apiCommonService.checkErrorNoSearchData(response);
          // }else{
          //   this.apiCommonService.checkError(response);
          // }

          // if(response.responseList != null && response.responseList.length != 0){
          //   this._getFileListResult$.next(response);
          //   return true;
          // }
          // response.responseList = [];
          // this._getFileListResult$.next(response);
          // return false;
          this.apiCommonService.checkError(response);
          this._getFileListResult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'sys', 'SZZA016A');
          return throwError(err.message);
        }));
  }
}